var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"section-heading",class:_vm.hasbackground ? 'background-blue':null},[(_vm.count)?_c('div',{staticClass:"count"},[_vm._v(_vm._s(_vm.count))]):_vm._e(),_c('h4',[_vm._v(_vm._s(_vm.headingText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }